import React from 'react';
import { Collapse, ConfigProvider } from 'antd';
import useDefaultTrebbleAntDTokenConfig from '../helper/useDefaultTrebbleAntDTokenConfig';

const { Panel } = Collapse;

interface TrebbleCollapseProps {
  activeKey?: string | string[];
  defaultActiveKey?: string | string[];
  bordered?: boolean;
  accordion?: boolean;
  ghost?: boolean;
  size?: 'large' | 'middle' | 'small';
  expandIconPosition?: 'start' | 'end';
  className?: string;
  style?: React.CSSProperties;
  onChange?: (key: string | string[]) => void;
  children?: React.ReactNode;
}

interface TrebblePanelProps {
  header?: React.ReactNode;
  key: string;
  disabled?: boolean;
  forceRender?: boolean;
  showArrow?: boolean;
  extra?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const TrebbleCollapse: React.FC<TrebbleCollapseProps> = ({
  activeKey,
  defaultActiveKey,
  bordered = true,
  accordion = false,
  ghost = false,
  size = 'middle',
  expandIconPosition = 'start',
  className = '',
  style,
  onChange,
  children,
  ...props
}) => {
  const tokenConfig = useDefaultTrebbleAntDTokenConfig();
  
  const combinedClassName = `trebble-collapse ${className}`;
  
  return (
    <ConfigProvider theme={tokenConfig}>
      <Collapse
        activeKey={activeKey}
        defaultActiveKey={defaultActiveKey}
        bordered={bordered}
        accordion={accordion}
        ghost={ghost}
        size={size}
        expandIconPosition={expandIconPosition}
        className={combinedClassName}
        style={style}
        onChange={onChange}
        {...props}
      >
        {children}
      </Collapse>
    </ConfigProvider>
  );
};

const TrebblePanel: React.FC<TrebblePanelProps> = ({
  header,
  key,
  disabled = false,
  forceRender = false,
  showArrow = true,
  extra,
  className = '',
  style,
  children,
  ...props
}) => {
  const combinedClassName = `trebble-panel bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 ${className}`;
  
  return (
    <Panel
      header={header}
      key={key}
      disabled={disabled}
      forceRender={forceRender}
      showArrow={showArrow}
      extra={extra}
      className={combinedClassName}
      style={style}
      {...props}
    >
      <div className="text-gray-900 dark:text-gray-100">
        {children}
      </div>
    </Panel>
  );
};

// Export both components
export { TrebblePanel };
export default TrebbleCollapse; 